

































































import type { PropType } from '@nuxtjs/composition-api';
import {
  computed,
  defineComponent,
  useContext,
  useRouter
} from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import VaimoIconSVG from 'atoms/VaimoIconSVG.vue';

import { validateFraction } from '~/diptyqueTheme/helpers/priceFormatter';
import {
  getProductCardPrice,
  hasDynamicPrice,
  hasFixedPrice
} from '~/diptyqueTheme/helpers/productGetters';
import { useAddToCart } from '~/helpers/cart/addToCart';
import type { CategoryInterface } from '~/modules/catalog/category/types';
import {
  getName,
  getPLPDescription,
  getProductThumbnailImage,
  getSlug
} from '~/modules/catalog/product/getters/productGetters';
import type { Product } from '~/modules/catalog/product/types';
import useCart from '~/modules/core/composables/useCart';

export default defineComponent({
  name: 'VaimoCrossSellProduct',
  components: {
    SfLink,
    VaimoIconSVG,
    VaimoBanner: () => import('atoms/VaimoBanner.vue')
  },
  props: {
    product: {
      required: true,
      type: Object as PropType<Product>
    },
    withLoadCart: Boolean
  },
  setup(props) {
    const { addItemToCart, loading } = useAddToCart();
    const { localePath } = useContext();
    const { cart } = useCart();
    const router = useRouter();

    const hasAddToCartButton = computed<boolean>(() => {
      return !hasDynamicPrice(props.product) && !hasFixedPrice(props.product);
    });

    const addProductToCart = (product) => {
      addItemToCart(product);
    };

    const productQuantity = computed<number>(() => {
      return (
        cart.value?.items?.find(
          (item) => item.product.uid === props.product.uid
        )?.quantity || 0
      );
    });

    const getProductLink = (product: Product): string => {
      return `${getSlug(
        product as Product,
        product?.categories?.[0] as CategoryInterface
      )}`;
    };

    const goToProduct = async (product) => {
      const link = getProductLink(product);

      await router.push(localePath(link));
    };

    const getters = {
      getProductLink,
      getName,
      getPLPDescription,
      getProductThumbnailImage,
      getSlug,
      getProductCardPrice
    };

    return {
      hasAddToCartButton,
      productQuantity,
      loading,
      ...getters,
      addProductToCart,
      getProductCardPrice,
      goToProduct,
      validateFraction
    };
  }
});
